import React from "react";

interface Props {
    points: Point[];
    selectedShot: Point | null;
    onClick: (shot: Point | null) => void;
}

export default function Events({ points, selectedShot, onClick }: Props): JSX.Element {
    return (
        <table className="w-full rounded-lg bg-blue-zodiac-800">
            <thead>
                <tr>
                    <th className="w-1/2 p-4 text-left font-medium uppercase">
                        Time
                    </th>
                    <th className="w-1/2 p-4 text-left font-medium uppercase">
                        {`Event (${points.length})`}
                    </th>
                </tr>
            </thead>
            <tbody>
                {points.map((point) => (
                    <tr
                        key={point.start}
                        onClick={() => onClick(point.start === selectedShot?.start ? null : point)}
                        className={"odd:bg-blue-zodiac-500 even:bg-blue-zodiac-800 cursor-pointer text-sm "
                            + `${point.start === selectedShot?.start ? "border-red-600 border-2" : ""}`}
                    >
                        <td className="w-1/2 p-4 text-left text-sm">
                            {friendlyTime(point.start)}
                        </td>
                        <td className="w-1/2 p-4 text-left text-sm">
                            {eventLabel(point)}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

function zeroPad(n: number): string {
    return n < 10 ? `0${n.toFixed(0)}` : n.toFixed(0);
}

function friendlyTime(time: number): string {
    const minutes = Math.floor(time / 60);
    const seconds = time - minutes * 60;
    return `${zeroPad(minutes)}:${zeroPad(seconds)}`;
}

function eventLabel(point: Point): string {
    if (point.outcome.result === "Fault") {
        return `${point.outcome.player} - Fault`;
    }
    if (point.outcome.shot === "server") {
        return `${point.outcome.player} - ${friendlyResult(point.outcome.result)} - Fault`;
    }
    return `${point.outcome.player} - ${friendlyResult(point.outcome.result)} - ${point.outcome.shot}`;
}

function friendlyResult(result: Result): string {
    switch (result) {
        case "Fault": return "Fault";
        case "L": return "Loss";
        case "W": return "Win";
        case "Finish": return "Finish";
        default: return "?";
    }
}
